import { FormSelect } from "../../../../components/ui/Input/FormSelector/FormSelect";
import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";

interface EnvironmentalDataProcessedFieldsProps {
  vm: IngredientRegisterViewModel;
}

/** PROCESSED-ingredient environmental fields — shown when `derivePackageFlags` resolves `processIngredient`. */
const EnvironmentalDataProcessedFields = ({ vm }: EnvironmentalDataProcessedFieldsProps) => {
  return (
    <div className="tw-grid tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-2">
      <FormSelect
        control={vm.control}
        name="specify_ingredient"
        label="Specify Ingredient"
        options={vm.specifyIngredientOptions}
        placeholder="Specify Ingredient"
        required
        onChange={vm.onSpecifyIngredientChange}
      />
      <FormSelect
        control={vm.control}
        name="country"
        label="Country"
        options={vm.countryOptions}
        placeholder="Select country"
        onChange={value => vm.onCountryChange(Number(value))}
      />
    </div>
  );
};

export default EnvironmentalDataProcessedFields;
